// extracted by mini-css-extract-plugin
module.exports = {"layout":"SearchLayout_layout__8cHh_","input":"SearchLayout_input__zf6_V"};